import { fetchCountCountryDataApi, getUsersByCountryApi, disableMemberApi, enableMemberApi, getAllDemographicsDataByUserApi} from '../api/country'
import {requestStarted,requestCompleted} from "./common"


export const setCountCountryList =(response) => {
  return {
    type : "SET_COUNTRY_COUNT_LIST",
    response
  }
}

export const setCountryUsersList =(response) => {
  return {
    type : "SET_COUNTRY_USERS_LIST",
    response
  }
}

export const setDataOnShowMember = (countryData) => {
  return{
    type : "SET_DATA_SHOW_COUNTRY_USERS",
    countryData 
  }
}

export const setDemographicsDataByUser =(response) => {
  return {
    type : "SET_DEMOGRAPHICS_DATA_BY_USER",
    response
  }
}

//emptyResponseUserDemographicsData
export const emptyResponseUserDemographicsData =() => {
  return {
    type : "SET_EMPTY_RES_DEMOGRAPHICS_DATA_BY_USER"
  }
}

//fetchAllCoupons
export const fetchCountCountryData=() =>{
  return dispatch =>{
      dispatch(requestStarted());
      fetchCountCountryDataApi().then((result) =>{
       dispatch(requestCompleted());
        dispatch(setCountCountryList(result));
    });
  }
}

//getUsers
export const getUsers=(country, from) =>{
  return dispatch =>{
      dispatch(requestStarted());
      getUsersByCountryApi(country, from).then((result) =>{
       dispatch(requestCompleted());
        dispatch(setCountryUsersList(result));
    });
  }
}

//disableMember
export const disableMember=(id) =>{
  return dispatch =>{
      dispatch(requestStarted());
      disableMemberApi( id).then((result) =>{
       dispatch(requestCompleted());
        dispatch(setCountryUsersList(result));
    });
  }
}

//enableMember
export const enableMember=(data) =>{
  return dispatch =>{
      dispatch(requestStarted());
      enableMemberApi( data).then((result) =>{
       dispatch(requestCompleted());
       if(result.success){
        dispatch(setCountryUsersList(result));
       }else{
         alert(result.message);
       }
        
    });
  }
}

//getAllDemographicsDataByUser
export const getAllDemographicsDataByUser=(catid, uid) =>{
  return dispatch =>{
      dispatch(requestStarted());
      getAllDemographicsDataByUserApi(catid, uid).then((result) =>{
       dispatch(requestCompleted());
       if(result.success){
        dispatch(setDemographicsDataByUser(result));
       }else{
         alert(result.message);
       }
    });
  }
}


// WEBPACK FOOTER //
// ./src/actions/country.js